const ESTATE_KEY = ':estate'

const Routes = {
    ROOT: `/${ESTATE_KEY}?`,
    DASHBOARD: `/${ESTATE_KEY}/dashboard/:dashboard?`,
    LANDING: `/${ESTATE_KEY}`,
    SETUP: '/configure/:device?',
    LOGIN: '/login',
    'LOGIN:CALLBACK': '/login/callback',
    'LOGIN:SESSION': '/login/:session?',
    CONFIGURE: `/configure-legacy/:device?`,
    CONTENT: `/${ESTATE_KEY}/content/:channel?/:playlist?`,
    'CONTENT:RAW': `/${ESTATE_KEY}/content`,
    'CONTENT:CHANNELS': `/${ESTATE_KEY}/content/channels`,
    'CONTENT:LAYERS': `/${ESTATE_KEY}/content/layers`,
    'CONTENT:MEDIA': `/${ESTATE_KEY}/content/media`,
    'CONTENT:MEDIA:DETAILS': `/${ESTATE_KEY}/content/media/:media`,
    'CONTENT:PLAYLISTS': `/${ESTATE_KEY}/content/playlists`,
    CONTENT_PUSH: `/${ESTATE_KEY}/content-push`,
    CONTENT_PUSH_FORM: `/${ESTATE_KEY}/content-push/edit/:id?`,
    'CONTENT_PUSH_FORM:EDIT': `/${ESTATE_KEY}/content-push/edit/`,
    'CONTENT_PUSH_FORM:NEW': `/${ESTATE_KEY}/content-push/edit`,
    'ESTATE:LIST': `/${ESTATE_KEY}/estate/list`,
    'ESTATE:MAP': `/${ESTATE_KEY}/estate/map`,
    /**
     * @deprecated Use `ESTATE_STORE` with `buildRoute`
     */
    'ESTATE:STORE': `/${ESTATE_KEY}/estate/store/`,
    ESTATE_STORE: `/${ESTATE_KEY}/estate/store/:code/:search?`,
    /**
     * @deprecated Use `ESTATE_STORE` with `buildRoute`
     */
    'ESTATE:STORE:ID:SEARCH': `/${ESTATE_KEY}/estate/store/:code/:search`,
    /**
     * @deprecated Use `ESTATE_STORE` with `buildRoute`
     */
    'ESTATE:STORE:ID': `/${ESTATE_KEY}/estate/store/:code`,
    REPORTING_DASHBOARDS: `/${ESTATE_KEY}/reporting/:dashboard?`,
    RENDER: `/${ESTATE_KEY}/render/:project?`,
    REPORTS: `/${ESTATE_KEY}/reports/:report?`,
    STATISTICS: `/${ESTATE_KEY}/statistics`,
    'STATISTICS:HOURS': `/${ESTATE_KEY}/statistics/:store?/:hours?`,
    LOGS: `/${ESTATE_KEY}/logs`,
    ERROR: `/${ESTATE_KEY}/error`,
    SELF_SERVE: `/${ESTATE_KEY}/self-serve/:page?/:id?`,
    SELF_SERVE_PROMOS: `/${ESTATE_KEY}/self-serve/promos/:promo?`,
    SELF_SERVE_ACCOLADES: `/${ESTATE_KEY}/self-serve/accolades`,
    SELF_SERVE_CREDITS: `/${ESTATE_KEY}/self-serve/credits/:credit?`,
    SELF_SERVE_TICKET_SIZES: `/${ESTATE_KEY}/self-serve/ticket-sizes/:ticketSize?`,
    SELF_SERVE_VARIANTS: `/${ESTATE_KEY}/self-serve/ticket-variants/:variant?`,
    SELF_SERVE_QUIET_HOURS: `/${ESTATE_KEY}/self-serve/quiet-hours`,
    SELF_SERVE_OEL: `/${ESTATE_KEY}/self-serve/oel`,
    OPERATIONS_HUB: `/${ESTATE_KEY}/operations-hub`,
}

const buildRoute = (route, params = {}) =>
    Object.keys(params)
        .reduce((outputRoute, key) => outputRoute.replace(new RegExp(`:${key}\\??`, 'g'), params[key]), route)
        .replace(/\/:[A-Za-z]+\?/g, '')

export default Routes

export { ESTATE_KEY, buildRoute }
